// Interim class for a selectable option tile (template, block, section, kit pickers)
// until twreact-ui ships one: https://github.com/dreamtree-org/dreamtree-org.twreact-ui/issues/185
export const OPTION_TILE_BASE = 'rounded-lg border p-3 text-left';
export const OPTION_TILE = `${OPTION_TILE_BASE} border-[var(--app-border)] hover:border-primary-400 hover:bg-primary-50`;
